import { useNavigate } from 'react-router-dom'
import Header from '../components/Header'
import Footer from '../components/Footer'

export default function Security() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-[#0a0e17]">
      <Header />

      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <h1
          className="text-4xl md:text-5xl font-bold text-white mb-4 text-center"
          style={{ fontFamily: "'Orbitron', sans-serif" }}
        >
          Security &amp; Trust
        </h1>
        <p className="text-gray-400 text-center mb-12 text-lg">
          How we protect your data and keep your information safe.
        </p>

        <div className="space-y-6">
          <div className="card">
            <h2 className="text-xl font-bold text-white mb-3">Data Protection</h2>
            <p className="text-gray-300 leading-relaxed">
              All data is encrypted in transit and at rest using enterprise-grade encryption standards.
              Our database infrastructure is hosted on a secure cloud platform with strict access controls,
              automated backups, and comprehensive disaster recovery protocols.
            </p>
          </div>

          <div className="card">
            <h2 className="text-xl font-bold text-white mb-3">Authentication Security</h2>
            <p className="text-gray-300 leading-relaxed">
              User identity management is handled by a secure authentication provider that implements
              industry-standard security practices including secure password hashing, session management,
              and email verification. We never store passwords in plaintext.
            </p>
          </div>

          <div className="card">
            <h2 className="text-xl font-bold text-white mb-3">Payment Security</h2>
            <p className="text-gray-300 leading-relaxed">
              All payment processing is handled by Stripe, a PCI DSS Level 1 certified payment processor.
              ScamView never sees, stores, or processes your credit card information. Card details are
              entered directly on Stripe's secure checkout page and never touch our servers.
            </p>
          </div>

          <div className="card">
            <h2 className="text-xl font-bold text-white mb-3">Privacy by Design</h2>
            <p className="text-gray-300 leading-relaxed">
              We follow a minimal data retention philosophy. Message content submitted for scanning is
              analyzed in real-time and is not permanently stored. Scan results are cached for 24 hours
              to improve performance, then automatically purged. We never sell, share, or monetize
              your personal data.
            </p>
          </div>

          <div className="card">
            <h2 className="text-xl font-bold text-white mb-3">Infrastructure</h2>
            <p className="text-gray-300 leading-relaxed">
              ScamView runs on a modern, distributed architecture. Our services are deployed globally
              to ensure low-latency responses and high availability. All API endpoints are protected
              by authentication and rigorous rate limits to prevent abuse.
            </p>
          </div>

          <div className="card">
            <h2 className="text-xl font-bold text-white mb-3">Strict Data Isolation</h2>
            <p className="text-gray-300 leading-relaxed">
              Our architecture enforces strict data isolation policies. This means users can only access
              their own data — scans, credit history, and profile information are logically isolated
              per user at the fundamental database level, ensuring privacy and security.
            </p>
          </div>

          <div className="card border-cyan-500/20">
            <h2 className="text-xl font-bold text-white mb-3">Vulnerability Reporting</h2>
            <p className="text-gray-300 leading-relaxed mb-4">
              We take security seriously. If you discover a vulnerability, please report it responsibly
              so we can address it promptly.
            </p>
            <p className="text-gray-300">
              Contact us at{' '}
              <a href="mailto:security@scamview.ai" className="text-cyan-400 hover:text-cyan-300 transition">
                security@scamview.ai
              </a>
            </p>
          </div>
        </div>

        <div className="text-center pt-12">
          <button onClick={() => navigate('/privacy')} className="btn-secondary mr-4">
            Privacy Policy
          </button>
          <button onClick={() => navigate('/terms')} className="btn-secondary">
            Terms of Service
          </button>
        </div>
      </main>

      <Footer />
    </div>
  )
}
